import { render } from "./SoundMeasure.vue?vue&type=template&id=88787938&scoped=true"
const script = {}

import "./SoundMeasure.vue?vue&type=style&index=0&id=88787938&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-88787938"

export default script